import * as React from 'react';
import '../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { closeModal, CloseModal } from 'src/actions/modal';
import { Dispatch, connect } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';

interface DispatchProps {
  sendAgain(): void;
}

interface Props extends DispatchProps {
  modalRef?: Modal;
}

const PasswordRecoverySuccess: React.StatelessComponent<Props> = (
  props: Props
) => (
    <div className="modal-content">
      <div className="modal-header">
        <p className="text-right">
          <span
            className="close-med pointer"
            onClick={() => props.modalRef!.modal('hide')}
          />
        </p>
        <img
          src="/img/the-crowd-angel.png"
          alt="logo"
        />
        <div className="gap-20" />
        <hr />
      </div>
      <div className="modal-body">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.sendAgain();
          }}
        >
          <h3 className="deco-title c-black-text">
            Comprueba tu buzón de correo
          </h3>
          <div className="gap-20" />
          <p>
            Te hemos enviado un email con instrucciones de cómo crear una nueva contraseña.
            <br />
            <br />
            <strong>
              ¿No te ha llegado el correo de recuperación?
            </strong>
          </p>
          <button
            type="submit"
            className="btn btn-primary"
          >
            Volver a enviar
          </button>
        </form>
      </div>
    </div>
  );

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    sendAgain: (): CloseModal => {
      return dispatch(closeModal());
    }
  };
};

export default connect(null, mapDispatchToProps)(PasswordRecoverySuccess);



// WEBPACK FOOTER //
// ./src/modules/modals/password-recovery/PasswordRecoverySuccess.container.tsx